import React from 'react';
import { SvgIcon } from '../../';
function TickIcon(props) {
    return (React.createElement(SvgIcon, { ...props },
        React.createElement("g", { stroke: "currentColor", strokeLinecap: "round", strokeWidth: "3", fill: "none" },
            React.createElement("path", { d: "M3 12.58l5.31 5.3M8.3 17.88L20.7 5.5" }))));
}
export default TickIcon;
//# sourceMappingURL=TickIcon.js.map